import React from 'react';
import { useNavigate } from 'react-router-dom';
import { useSubscription } from '../../hooks/useSubscription';

export default function TrialBanner() {
  const navigate = useNavigate();
  const { isTrialing, trialDaysRemaining } = useSubscription();

  if (!isTrialing || trialDaysRemaining === null) return null;

  const dayNumber = 7 - trialDaysRemaining;

  return (
    <button
      type="button"
      onClick={() => navigate('/pricing')}
      className="flex items-center gap-2 w-full px-4 py-2 border-0 border-b border-tomato-500/15 bg-gradient-to-r from-tomato-500/10 to-tomato-500/5 hover:bg-tomato-500/15 text-tomato-400 dark:text-tomato-400 text-tomato-600 text-xs font-semibold transition-colors cursor-pointer"
    >
      <span className="w-1.5 h-1.5 rounded-full bg-tomato-600 dark:bg-tomato-500 shadow-[0_0_6px_currentColor] shrink-0 animate-pulse" />
      <span className="flex-1 text-left">Day {dayNumber} of 7 — Premium Trial</span>
      <span className="text-[10px] uppercase tracking-wider opacity-70 text-tomato-600 dark:text-tomato-500">View Plans</span>
    </button>
  );
}
